import { Text, } from "@bracket/ui";
import { formatWEI } from "@formatters";
import { useWallet } from "@store";
import { getTheme, } from "@bracket/ui/themes";
import { type FunctionComponent } from "react";


import styled from "styled-components";



export declare type BrktBalancePillProps = {
	// No additional props needed as the component uses wallet context
};

/**
 * BrktBalancePill component that displays the user's ETH balance in a styled pill format.
 * 
 * @param props - BrktBalancePillProps
 * @returns JSX.Element | null - The balance pill component or null if anonymous
 */
export const BrktBalancePill: FunctionComponent<BrktBalancePillProps> = () => {

	const { anonymous, eth_balance } = useWallet();

	if (anonymous) {
		return null;
	}

	return (
		<BalancePill>
			<Text size="sm">
				{formatWEI(eth_balance, 18)} ETH
			</Text>
		</BalancePill>
	);
};



const BalancePill = styled.div`
	background: ${() => getTheme().surface};
	padding: 0.5rem 1rem;
	border-radius: 1rem;
	font-size: 0.875rem;
	font-weight: 500;
	color: white;
`;
